/**
 * Konfig pre paths
 */
export const pathsConfig = {

  /** pocet drah */
  tracks: 8,

  /** percenta pre pociatocne pozicie hracov */
  positionsStartIntro: 0,

  /** offset pre positionsStartIntro pre nahodne umiestnenie */
  positionsIntroOffset: {
    min: 0.005,
    max: 0.01
  },

  /** percenta pre pociatocne pozicie hracov */
  positionsStart: 0,

  /** kedy ma zacat finish faza podla % na krivke */
  positionsFinish: 0.5,

  /** kedy je preslap */
  positionFoul: 0.87855,

  /** pozicia pre emocie */
  positionEmotions: 0.84,

  /** sirka od jednej drahy k druhej - vypocitane */
  pathWidth: 1.229,

  /** offset pre pivotPoint v metroch */
  pivotPointOffset: 1.05
}
